document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-honey-one-home]').forEach((root) => {
    const menu = root.querySelector('.hone-menu');
    const mobileNav = root.querySelector('.hone-mobile-nav');
    if (menu && mobileNav) {
      menu.addEventListener('click', () => {
        const open = mobileNav.classList.toggle('is-open');
        menu.setAttribute('aria-expanded', String(open));
      });
      mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
        mobileNav.classList.remove('is-open');
        menu.setAttribute('aria-expanded', 'false');
      }));
    }

    root.querySelectorAll('[data-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-src]').forEach((button) => {
        button.addEventListener('click', () => {
          main.src = button.dataset.gallerySrc;
          main.alt = button.dataset.galleryAlt || '';
          gallery.querySelectorAll('[data-gallery-src]').forEach((item) => item.classList.toggle('is-active', item === button));
        });
      });
    });

    root.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
      const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
      const previous = carousel.querySelector('[data-hero-prev]');
      const next = carousel.querySelector('[data-hero-next]');
      if (slides.length < 2) return;

      let activeIndex = 0;
      let timer;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (!reducedMotion) timer = window.setInterval(() => showSlide(activeIndex + 1), 7000);
      };

      previous?.addEventListener('click', () => { showSlide(activeIndex - 1); start(); });
      next?.addEventListener('click', () => { showSlide(activeIndex + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.heroDot)); start(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      start();
    });
  });
});
